import Vuex from 'vuex';
import Vue from 'vue';
import {
    getCtaText,
    getCtaLink,
    getUserInput,
    getUserInputByKey,
    getUpdateCount,
    getTermsRange,
    getAmountRange,
} from '@app/store/shared/getters';

import { setUpdateCount, setTotal, setRate, setData, setAmount } from '@app/store/shared/actions';

import {
    setDataMutation,
    setTotalMutation,
    setRateMutation,
    setUpdateCountMutation,
} from '@app/store/shared/mutations';

const deposit = (data) => ({
    state: {
        ...data,
        total: 0,
        rate: 0,
        updateCount: 0,
        currencyMap: {
            RUR: {
                symbol: '₽',
                shortTitle: 'рубли',
                title: 'Рубли',
            },
            USD: {
                symbol: '$',
                shortTitle: 'доллары',
                title: 'Доллары',
            },
            EUR: {
                symbol: '€',
                shortTitle: 'евро',
                title: 'Евро',
            },
        },
    },
    getters: {
        getCtaText,
        getCtaLink,
        getUserInput,
        getUserInputByKey,
        getUpdateCount,
        getTermsRange,
        getAmountRange,
        getSelectedCurrency(state, getters) {
            return getters.getUserInputByKey('currency');
        },
        getDataByKey(state, getters) {
            return (key) => state.data[getters.getSelectedCurrency][key];
        },
        getCurrencyShortTitle(state, getters) {
            return state.currencyMap[getters.getSelectedCurrency].shortTitle;
        },
        getCurrencySymbol(state, getters) {
            return state.currencyMap[getters.getSelectedCurrency].symbol;
        },
        getCurrencyList(state) {
            return Object.keys(state.data).map(function (key) {
                return { val: key, title: state.currencyMap[key].title };
            });
        },
        getCurrencyMeasureUnitTitle(state, getters) {
            return getters.getCurrencyShortTitle;
        },
        getIsNoAmountMax(state) {
            return state.isNoAmountMax;
        },
        getMinAmount(state, getters) {
            return getters.getDataByKey('amount').min;
        },
        getIsTermInDays(state) {
            return state.isTermInDays;
        },
        getTermsList(state, getters) {
            const { values } = getters.getDataByKey('term');

            if (!state.isTermInDays) {
                return values.map(function (item) {
                    return { val: item.termMinInDays, title: item.termMinInMonths };
                });
            }

            return values.map(function (item) {
                return { val: item.min, title: item.min };
            });
        },
        getTermMeasureUnitTitle(state, getters) {
            const { values } = getters.getDataByKey('term');

            return typeof values[0] !== 'number' ? 'дни' : 'месяцы';
        },
        getIsRefillable(state) {
            return state.isRefillable;
        },
        // TODO: rewrite it to handle engine errors more smarty
        getTotal(state, getters) {
            // in case we get float here
            return state.total ? parseInt(state.total) : getters.getUserInputByKey('amount');
        },
        // TODO: rewrite it to handle engine errors more smarty
        getRate(state) {
            return state.rate ? state.rate : [0];
        },
        getIsCapitalized(state) {
            return state.isCapitalized;
        },
    },
    actions: {
        setCurrency({ dispatch, state }, payload) {
            const termMin = state.data[payload.val].term.min;
            const amountMin = state.data[payload.val].amount.min;

            dispatch('setData', payload);
            dispatch('setData', {
                key: 'term',
                val: state.isTermInDays ? termMin : termMin.termMinInDays,
                suppressUpdateCount: true,
            });
            dispatch('setData', { key: 'amount', val: amountMin });
        },
        // TODO: refactor
        setTerm({ dispatch }, payload) {
            return dispatch('setData', payload);
        },
        setUpdateCount,
        setTotal,
        setRate,
        setData,
        setAmount,
    },
    mutations: {
        setDataMutation,
        setTotalMutation,
        setRateMutation,
        setUpdateCountMutation,
    },
});

Vue.use(Vuex);

const createStore = ({ data }) => {
    return new Vuex.Store({
        modules: {
            deposit: deposit(data),
        },
    });
};

export default createStore;
